<script setup lang="ts">
import type { FaqItem } from '~/packages/commerce/types/faq';

defineProps<{
    faqItems: FaqItem[];
}>();

const runtimeConfig = useRuntimeConfig();
const content_Url = runtimeConfig.public.karriere.content.url;
</script>

<template>
    <section class="flex max-w-[1200px] flex-col gap-6">
        <BaseHeading as="h2" variant="xl-500">
            Häufig gestellte Fragen
        </BaseHeading>
        <div>
            <CommBaseCollapse
                v-for="(faqItem, index) in faqItems"
                :key="`faq-item-${index}`"
                class="border-b text-left"
            >
                <template #trigger>
                    <BaseHeading
                        as="h3"
                        variant="lg-500"
                        class="hidden py-5 text-left md:block"
                    >
                        {{ faqItem.question }}
                    </BaseHeading>
                    <BaseHeading
                        as="h3"
                        variant="base-700"
                        class="py-5 text-left md:hidden"
                    >
                        {{ faqItem.question }}
                    </BaseHeading>
                </template>
                <BaseText variant="lg-400" class="hidden md:block">
                    <p class="pb-4" v-html="faqItem.answer" />
                </BaseText>
                <BaseText variant="base-400" class="md:hidden">
                    <p class="pb-4" v-html="faqItem.answer" />
                </BaseText>
            </CommBaseCollapse>
        </div>
        <BaseText>
            <JamBaseLink :href="`${content_Url}/hr/faqs`" external>
                Alle FAQs
            </JamBaseLink>
        </BaseText>
    </section>
</template>
